<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-md">
                <Title>Pricing</Title>
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'Pricing'
})
</script>

<style scoped lang="scss">

</style>
